"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EPreferencesFilter = exports.EPersonalDataCheck = exports.EFieldType = void 0;
var EFieldType;
(function (EFieldType) {
    EFieldType["TEXT"] = "TEXT";
    EFieldType["SIGNATURE"] = "SIGNATURE";
    EFieldType["EMAIL"] = "EMAIL";
    EFieldType["URL"] = "URL";
    EFieldType["TELEPHONE"] = "TELEPHONE";
    EFieldType["CATEGORY"] = "CATEGORY";
    EFieldType["COMMENT"] = "COMMENT";
    EFieldType["INTEGER"] = "INTEGER";
    EFieldType["LENGTH"] = "LENGTH";
    EFieldType["CHECKBOX"] = "CHECKBOX";
    EFieldType["REFERENCE"] = "REFERENCE";
    EFieldType["NON_SEARCHABLE_TEXT"] = "NON_SEARCHABLE_TEXT";
    EFieldType["NON_SEARCHABLE_REFERENCE"] = "NON_SEARCHABLE_REFERENCE";
})(EFieldType = exports.EFieldType || (exports.EFieldType = {}));
var EPersonalDataCheck;
(function (EPersonalDataCheck) {
    EPersonalDataCheck["STANDARD"] = "STANDARD";
    EPersonalDataCheck["YES"] = "YES";
    EPersonalDataCheck["NO"] = "NO";
})(EPersonalDataCheck = exports.EPersonalDataCheck || (exports.EPersonalDataCheck = {}));
var EPreferencesFilter;
(function (EPreferencesFilter) {
    // Numbers
    EPreferencesFilter["CHOICE1"] = "[0-9]";
    // Phone
    EPreferencesFilter["CHOICE2"] = "[0-9\\- +]";
    // Alphanumerical
    EPreferencesFilter["CHOICE3"] = "[0-9a-z]";
    // Alphanumerical (Swedish)
    EPreferencesFilter["CHOICE4"] = "[0-9a-zA-Z\u00E5\u00E4\u00F6\u00C5\u00C4\u00D6_-]";
    // E-Mail
    EPreferencesFilter["CHOICE5"] = "[@_\\-\\.0-9a-zA-Z]";
    // E-mail (Swedish)
    EPreferencesFilter["CHOICE6"] = "[@_\\-\\.0-9a-zA-Z\u00E5\u00E4\u00F6\u00C5\u00C4\u00D6]";
})(EPreferencesFilter = exports.EPreferencesFilter || (exports.EPreferencesFilter = {}));
